export default __webpack_public_path__ + "static/Signifier-RegularItalic-5d629e4ac4cb7391bc2c63a9d4321a0a.woff2";